import axios from 'axios';
import { resolveApiBaseUrl } from './apiBase';

const TOKEN_KEY = 'admin_token';

const http = axios.create({
  baseURL: resolveApiBaseUrl(),
  timeout: 30000
});

http.interceptors.request.use((config) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) {
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

http.interceptors.response.use(
  (res) => {
    const body = res.data;
    if (body && typeof body.code === 'number' && body.code !== 200) {
      return Promise.reject(new Error(body.message || '请求失败'));
    }
    return res;
  },
  (err) => {
    if (err.response && err.response.status === 401) {
      localStorage.removeItem(TOKEN_KEY);
      if (!window.location.pathname.startsWith('/login')) {
        window.location.href = '/login';
      }
    }
    const body = err.response && err.response.data;
    const serverMsg = body && typeof body.message === 'string' ? body.message : '';
    if (serverMsg) {
      const next = new Error(serverMsg);
      next.response = err.response;
      return Promise.reject(next);
    }
    return Promise.reject(err);
  }
);

export default http;
